import { render } from "./MyUploadFile.vue?vue&type=template&id=519d58d9&scoped=true"
import script from "./MyUploadFile.vue?vue&type=script&lang=js"
export * from "./MyUploadFile.vue?vue&type=script&lang=js"

import "./MyUploadFile.vue?vue&type=style&index=0&id=519d58d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519d58d9"]])

export default __exports__